import React, { useMemo } from "react";
import { Link } from "react-router-dom";
import { BRANDS } from "@/data/brands";
import { useT } from "@/i18n/LanguageContext";

// Small logo strip pointing to every other brand page. Cached with useMemo
// so we don't re-filter BRANDS on every render.
export default function BrandOthers({ currentSlug }) {
  const { t } = useT();
  const others = useMemo(
    () => BRANDS.filter((b) => b.slug !== currentSlug),
    [currentSlug]
  );
  return (
    <section className="bg-neutral-50 border-t border-neutral-100">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10 py-16">
        <p className="overline text-[#25bfcf] mb-6">{t("brandPage.exploreOther")}</p>
        <div className="flex flex-wrap items-center gap-x-8 gap-y-6">
          {others.map((b) => (
            <Link
              key={b.slug}
              to={`/brands/${b.slug}`}
              data-testid={`brand-page-other-${b.slug}`}
              className="group inline-flex items-center h-16 opacity-70 hover:opacity-100 transition-opacity"
              aria-label={b.name}
            >
              <img
                src={b.logo}
                alt={b.name}
                className={`${b.logoClass || "h-12 max-w-[180px]"} w-auto object-contain`}
              />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
